module.exports = __webpack_public_path__ + "static/media/606346899_desktop.d65e54be.jpg";